const matchMedia = typeof window !== "undefined" && window.matchMedia || matchMediaFallback;
function matchMediaFallback(_) {
  return {
    addListener() {
    },
    removeListener() {
    },
    matches: false
  };
}
function setupMatchMedia(_) {
}
export {
  matchMedia,
  setupMatchMedia
};
//# sourceMappingURL=matchMedia.js.map
